module.exports = {
  "CS_FE_Select_Product_VbhT": "Select the ‘PM and DEV Role’",
  "CS_status_Dibi_hJVY": "Continue ({{time_second}})",
  "CS_system_Submission_cEep": "Submit",
  "CS_1_WiFi_pyYD": "Wi-Fi",
  "CS_FE_You_can_yIrn": "Select the permission type you need below, then click Apply.",
  "CS_status_SYOk_iYUs": "B2B",
  "CS_Tools_Ark_System_Quick_Access_for_Permission_Application_See_permissions_OzjQ": "For more information, please refer to the Customer Service System Access Guidelines",
  "CS_status_ZoGi_sjyC": "Driver Center",
  "CS_1_Environment_Bitb": "Environment",
  "CS_1_View_Current_IOCz": "View current permissions",
  "CS_optimazation__CALn": "Your status was automatically changed to offline due to inactivity. Please refresh the page.",
  "CS_1_Upgrade_current_dlbi": "Elevate current permissions",
  "CS_optimazation_You_have_PlRk": "You have been idle in {{workbench_name}} for {{time_duration}} minute(s). Do you want to continue working in {{workbench_name}}?",
  "CS_optimazation__akmu": "Offline",
  "CS_Tools_Ark_System_Quick_Access_for_Permission_Application_Customer_service_oPui": "If you’re not a Customer Service Representative:",
  "CS_status_ixVR_bjQc": "Sales",
  "CS_feedback_Feedback_bGXI": "Feedback",
  "CS_optimazation__ZkZb": "Stay {{work_status}}",
  "CS_System_ZQjn_eCbz": "Previously trained skill type",
  "CS_status_CjDQ_uaVo": "Anti-fraud",
  "CS_Status_In_the_PrHj": "Taking a Bio-break",
  "CS_1_Thank_you_WUlL": "Thanks for your feedback!",
  "CS_status_ErSl_RYFT": "Call",
  "CS_1_Log_in_sMmF": "Sign out",
  "CS_status_HxNd_EpND": "Dashcam",
  "CS_status_HMDn_eBqC": "Engagement",
  "CS_status_zoxI_Nral": "The current service type is {{service_type}}",
  "CS_feedback_1_Please_IBbL": "1. Please describe the feature you were having an issue with and what happened",
  "CS_1_Closing_Online_tykf": "Disable Live Chat",
  "CS_Tools_Ark_System_Quick_Access_for_Permission_Application_Permission_Kapv": "Select your access permission",
  "CS_1_Open_automatic_PZyZ": "Turn on Auto Ticket Assignment",
  "CS_FE_Ark_Visitor_pMCT": "CRM View Permission",
  "CS_1_Enter_text_NYGo": "Enter text...",
  "CS_status_WEAx_MWhv": "Safety",
  "CS_System_lIGK_Ukwr": "Current skill type",
  "CS_optimazation_Telephone_workstations_TBZP": "Call Workbench",
  "CS_system_Name_of_QEFT": "Position Name",
  "CS_status_dweh_wRWT": "Onboarding review",
  "CS_Tools_Ark_System_Quick_Access_for_Permission_Application_Sorry_permissions_nBRG": "Sorry, you don’t have permission to access the system. To request permission, please follow the instructions below.",
  "CS_optimazation__work_JhhB": "You have been {{work_status}} for more than {{time_duration}} minutes. Do you want to remain {{work_status}}?",
  "CS_Workbench_Online_Customer_yXxN": "Live Chat Workbench",
  "CS_status_wfIq_oGhU": "Social media",
  "CS_Tools_Ark_System_Quick_Access_for_Permission_Application_Production_and_mGLI": "Select the permission type you need below, then click Apply.\n\nIf you’re on the customer service product and development team: Select the ‘PM and DEV Role‘\n\nFor other roles (IBT product and development, operations, or domestic staff): Select the ‘CRM View Permission (Role ID: 14211591)’",
  "CS_optimazation_Time_out_sqTe": "Timeout Reminder",
  "CS_1_Country_ilYw": "Country",
  "CS_1_Closed_automatic_jUvk": "Turn off Auto Ticket Assignment",
  "CS_1_System_Category_rAJC": "Business Category",
  "CS_status_aobY_gRor": "You have been {{status_name}} for more than {{hour_time}} hour(s). Do you want to stay {{status_name}}?",
  "CS_FE_If_you_lCHy": "If you’re on the customer service product and development team:",
  "CS_status_qORz_iUKj": "Collections",
  "CS_optimazation_The_status_hqOj": "Unable to switch status. Please log in to Genesys.",
  "CS_optimazation_After_the_dZsk": "Post-call Processing",
  "CS_Tools_Ark_System_Quick_Access_for_Permission_Application_Customer_service_vLUC": "If you’re a Customer Service Representative:",
  "CS_feedback_Please_upload_zHqW": "2. Please upload a complete image to help us know about the issue",
  "CS_system_Sectoral_information_JizK": "Department Info",
  "CS_optimazation__zXnN": "{{work_status}} Timeout",
  "CS_status_eJtD_Xawt": "Tech support",
  "CS_1_Personal_settings_eXQD": "Personal Settings",
  "CS_optimazation_Asynchronous_workstations_JwBF": "Written Workbench",
  "CS_status_YyJG_Khkr": "Frontline customer service",
  "CS_FE_Product_R_RxVt": "PM and DEV Role",
  "CS_1_Online_Customer_SvgB": "Live Chat is enabled",
  "CS_status_pySZ_YnQN": "Content review",
  "CS_1_Open_Online_umkV": "Enable Live Chat",
  "CS_1_Languages_hMbf": "Language",
  "CS_system_Immediate_superior_VDep": "Supervisor",
  "CS_1_Personal_settings_uOXW": "Personal Settings",
  "CS_FE_Choose_Ark_VJpl": "Select the ‘CRM View Permission (Role ID: 14211591)’",
  "CS_1_Permissions_MuvF": "Permissions",
  "CS_FE_If_you_WAuP": "If you have a different role (like IBT product and development, ops, or a China-based colleague):",
  "CS_status_ocdu_QQQW": "Video call",
  "CS_1_Automatic_Order_Mnnv": "Auto Ticket Assignment is on",
  "CS_optimazation_Make_sure_FVAQ": "Are you sure you want to switch the status of {{workbench_name}} from {{status_one}} to {{status_two}}? Once switched, the status of other workbenches will be set to {{status_three}}.",
  "CS_1_Comments_RcMN": "Submit",
  "CS_1_Notification_uJTM": "Notifications",
  "CS_Tools_Ark_System_Quick_Access_for_Permission_Application_Hello_permissions_SDxI": "Please contact your supervisor or local admin responsible for customer service permissions for assistance.",
  "status_400": "Having a meal...",
  "refreshPage": "Refresh page",
  "countDownBegin": "Operation after ",
  "infoChange": "The system category has been switched on another page. The system will not be able to save your changes. Please refresh the page.",
  "view": "View",
  "online": "Online environment",
  "message": "Messages",
  "changeStatusV1": "Are you sure you want to change your work status from ",
  "changeStatusV2": " to ",
  "changeStatusV3": "？",
  "time": "Date",
  "continue": "continue",
  "knowledge": "Data Base",
  "status_500": "Taking a break...",
  "artificial": "Direct msg",
  "countDownEnd": "S",
  "clickStartWorking": "To ensure data accuracy, please click Start to Work before using the system",
  "statusChange": "To accept tickets automatically, please set your work status to \"Available\".",
  "CS_Workbench_There_are_wmir": "Unable to change work status. Please first complete all live chats in progress.",
  "type": "Msg type",
  "status_200": "Training in progress...",
  "cancel": "cancel",
  "logout": "logout",
  "sendTo": "To",
  "satisfaction_content": "You have a survey that might take you about 5 minutes to finish. If you would like to complete it now, you can click the link below or the continue button to go to the survey page.",
  "CS_Workbench_Open_the_lnHa": "When using Live Chat Workbench, please ensure that your work status is set to “Available”.",
  "ticketNumber": " pending ticket(s)",
  "more": "More",
  "satisfaction_title": "A survey for you",
  "pre": "Pre-event environment",
  "customerService": "Call center",
  "status_300": "Meeting in progress...",
  "sendFrom": "From",
  "youhave": "You have ",
  "startWorking": "Start to Work",
  "small": "Acceptance environment",
  "offWorkV": "Are you sure you want to go offline? This will clock you out for the day.",
  "read": "Have read",
  "Settings": "Settings",
  "welcomeCS": "Welcome to the DiDi Global Customer Service System!",
  "cs-micro-front-end---more": "",
  "cs-micro-front-end---welcomeCS": "",
  "cs-micro-front-end---clickStartWorking": "",
  "cs-micro-front-end---startWorking": "",
  "cs-micro-front-end---status_200": "",
  "cs-micro-front-end---status_300": "",
  "cs-micro-front-end---status_400": "",
  "cs-micro-front-end---status_500": "",
  "cs-micro-front-end---offWorkV": "",
  "cs-micro-front-end---changeStatusV1": "",
  "cs-micro-front-end---changeStatusV2": "",
  "cs-micro-front-end---changeStatusV3": "",
  "cs-micro-front-end---cancel": "",
  "cs-micro-front-end---continue": "",
  "cs-micro-front-end---logout": "",
  "cs-micro-front-end---online": "",
  "cs-micro-front-end---pre": "",
  "cs-micro-front-end---small": "",
  "cs-micro-front-end---statusChange": "",
  "cs-micro-front-end---youhave": "",
  "cs-micro-front-end---ticketNumber": "",
  "cs-micro-front-end---view": "",
  "cs-micro-front-end---Settings": "",
  "cs-micro-front-end---infoChange": "",
  "cs-micro-front-end---refreshPage": "",
  "cs-micro-front-end---satisfaction_title": "",
  "cs-micro-front-end---satisfaction_content": "",
  "cs-micro-front-end---knowledge": "",
  "cs-micro-front-end---customerService": "",
  "cs-micro-front-end---artificial": "",
  "cs-micro-front-end---sendFrom": "",
  "cs-micro-front-end---sendTo": "",
  "cs-micro-front-end---type": "",
  "cs-micro-front-end---time": "",
  "cs-micro-front-end---read": "",
  "cs-micro-front-end---countDownBegin": "",
  "cs-micro-front-end---countDownEnd": "",
  "cs-micro-front-end---CS_Workbench_There_are_wmir": "",
  "cs-micro-front-end---CS_Workbench_Open_the_lnHa": "",
  "cs-micro-front-end---message": ""
}